import React, { useState, useEffect, useRef } from 'react';

import { SendEmail } from "../../Services/EmailService"
import { logPageViews, VerifyEmailAcc, ActivatingEmailAcc } from '../../Services/LoginService'
import { CheckEmailAcc, SignupTrial, AddTrialEmailAcc } from '../../Services/LoginService'
import { Row, Col, Container } from 'react-bootstrap';
import { Helmet } from 'react-helmet';
import '../../styles/SignupActivate.scss'
import { TextField, Modal, Button, Typography, FormControl, InputAdornment, IconButton, Stepper, Step, StepLabel, Box, Checkbox } from '@mui/material';
import { IconUser, IconBuilding, IconBriefcase, IconMapPin, IconPhone, IconMail, IconLock, IconEye, IconEyeOff, IconLogin, IconCheck, IconArrowForward, IconArrowLeft, IconArrowRight, IconBuildingCottage } from '@tabler/icons-react';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import { isLoggedIn } from '../../Services/Auth';
import { history } from '../../Services/History';
import { useHistory, useParams, useLocation } from "react-router-dom";
import { Theme, useTheme } from '@mui/material/styles';
import OutlinedInput from '@mui/material/OutlinedInput';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import Chip from '@mui/material/Chip';
import FormHelperText from '@mui/material/FormHelperText';
import FormControlLabel from '@mui/material/FormControlLabel';

const ActivateEmail = () => {
    const { id } = useParams();
    const [token, setToken] = useState('')
    const [reason, setReason] = useState('')
    const [generatepass, setgeneratepass] = useState('')
    const [isVerify, setisVerify] = useState(false)
    const [istrialmonth, setistrialmonth] = useState(false)
    const [isVerify2, setisVerify2] = useState(false)
    const params = new URLSearchParams(window.location.search);
    const email = params.get("email");
    // Input Validation on change
    //setToken(VerifyEmailAcc(id))
    useEffect(() => {

        logPage()
        async function logPage() {
            await logPageViews("Activate Email", id)
        }
        document.getElementById('loaderPage').style.display = 'none'
        async function Vemail() {
            document.getElementById('loaderPage').style.display = 'flex';
            setToken(await CheckEmailAcc(email))
        }
        if (isVerify) {

            
           
                const { fullName } = formValues;
                document.getElementById('loaderPage').style.display = 'none';
                setisVerify2(true)
                sendEmailTril(fullName, email, (generatepass));
                console.log(reason)
         
        } else {
            // document.getElementById('loaderPage').style.display = 'flex'
            Vemail()
        }


    }, [isVerify]);
    const [seconds, setSeconds] = useState(7);
    // Email template
    const [template, setTemplate] = useState('');
    useEffect(() => {
        fetch('/WelcomeEmailTrial.html')
            .then(response => response.text())
            .then(data => setTemplate(data));
    }, []);
    const history = useHistory();
    const sendEmailTril = (fullName, email, password) => {
        console.log(fullName, email, password)
        if (template) {
            //console.log(email)
            const processedTemplate = template
                .replace(/{fullName}/g, fullName)
                .replace('{email}', email)
                .replace('{password}', password);
            SendEmail(
                email,
                processedTemplate,
                '',
                'Welcome to your MIMS Drugs4dent Free Trial'
            );
            setTimeout(() => {
                //setOpen(true)
            }, 1000);

        }
    };

    // Form fields
    const formFields = [
        { id: 'fullName', label: 'Full Name', icon: <IconUser sx={{ fontSize: 16, pl: '10px' }} />, type: 'text' },
        { id: 'companyName', label: 'Company Name', icon: <IconBuilding sx={{ fontSize: 16, pl: '10px' }} />, type: 'text' },
        { id: 'occupation', label: 'Occupation', icon: <IconBriefcase sx={{ fontSize: 16, pl: '10px' }} />, type: 'text' },
        { id: 'address', label: 'Address', icon: <IconMapPin sx={{ fontSize: 16, pl: '10px' }} />, type: 'text' },
        { id: 'phoneNumber', label: 'Phone Number', icon: <IconPhone sx={{ fontSize: 16, pl: '10px' }} />, type: 'tel' },
    ];
    // Input Validation on change
    useEffect(() => {

        if (token !== '') {
            if (token.success = 'true') {
                console.log(token.data)
                setisVerify(token.data.isSuccess)
                setistrialmonth(token.data.monthTrial)
                setReason(token.data.reason)
                setgeneratepass(token.data.token)
                 document.getElementById('loaderPage').style.display = 'none'
                if (token.data.reason == 'addtrailbacktologin') {
                console.log(reason)
                history.push('/login');
            
            }

            }
        }
    }, [token]);

    // Sign up button disabler to prevent multiple clicks
    const [isButtonDisabled, setIsButtonDisabled] = useState(true);
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const [emailErrorMessage, setEmailErrorMessage] = useState('');
    const [passwordErrorMessage, setPasswordErrorMessage] = useState('');
    const [confirmPasswordErrorMessage, setConfirmPasswordErrorMessage] = useState('');
    const [countryList, setCountryList] = useState([]);
    const [existingEmails, setExistingEmails] = useState([]);
    // Input Validation on change
    const [isConfirmPasswordEnabled, setIsConfirmPasswordEnabled] = useState(false);
    // Function to immediately redirect to the login page
    const handleRedirect = () => {
        history.push('/login'); // Redirect to the login page
    };

    // Shrink label when there's an autofill value 
    const makeAnimationStartHandler = (fieldId) => (e) => {
        const autofilled = !!e.target?.matches("*:-webkit-autofill");
        if (e.animationName === "mui-auto-fill" || e.animationName === "mui-auto-fill-cancel") {
            setShrinked((prevShrinked) => ({ ...prevShrinked, [fieldId]: autofilled || e.target.value !== '', }));
        }
    };

    // Form fields error states
    const initialErrorstate = formFields.reduce((acc, field) => {
        acc[field.id] = false;
        return acc;
    }, {});
    // Form fields states
    const initialFieldState = formFields.reduce((acc, field) => {
        acc[field.id] = '';
        return acc;
    }, {});
    const initialShrinkState = formFields.reduce((acc, field) => {
        acc[field.id] = false;
        return acc;
    }, {});
    // Form fields focused states
    const initialFocusState = formFields.reduce((acc, field) => {
        acc[field.id] = false;
        return acc;
    }, {});
    const [error, setError] = useState(initialErrorstate);
    const [formValues, setFormValues] = useState(initialFieldState);
    const [focused, setFocused] = useState(initialFocusState);
    const [shrinked, setShrinked] = useState(initialShrinkState);

    // Validation logic for step 1
    const handleNext = (event) => {
        event.preventDefault();
        let isValid = true;
        //alert(country)
        formFields.slice(0, 4).forEach((field) => {
            const fieldValue = formValues[field.id]?.trim();
            //alert(age)
            if (field.id == "companyName" || field.id == "address" || field.id == "occupation") {
                //no validation needed
            }
            else {
                //validate  

                if (!fieldValue) {

                    setError((prevError) => ({ ...prevError, [field.id]: true }));
                    setFocused((prevFocused) => ({ ...prevFocused, [field.id]: false }));
                    setFormValues(prevValues => ({ ...prevValues, [field.id]: '', }));
                    setShrinked(prevShrinked => ({ ...prevShrinked, [field.id]: false, }));
                    isValid = false;
                } else {

                    setError((prevError) => ({ ...prevError, [field.id]: false }));
                    setFocused((prevFocused) => ({ ...prevFocused, [field.id]: true }));
                }


            }
        });


        // if (isValid) {
        //   setActiveStep((prevActiveStep) => prevActiveStep + 1);
        // }

    };
    const handleInputChange = (fieldId) => (e) => {
        const { value } = e.target;
        setFormValues((prevValues) => ({ ...prevValues, [fieldId]: value, }));
        setShrinked((prevShrinked) => ({ ...prevShrinked, [fieldId]: value !== '', }));
        setError((prevError) => ({ ...prevError, [fieldId]: false }));
        setFocused((prevFocused) => ({ ...prevFocused, [fieldId]: value !== '', }));

        if (fieldId === 'email') {
            setFocused((prevFocused) => ({ ...prevFocused, email: false, }));
            if (value.includes('@')) {
                if (!emailRegex.test(value)) {
                    setError((prevState) => ({ ...prevState, email: true }));
                    setEmailErrorMessage('Invalid email');
                } else {
                    if (existingEmails.includes(value)) {
                        setError((prevState) => ({ ...prevState, email: true }));
                        setEmailErrorMessage('Email already exists');
                        setFocused((prevFocused) => ({ ...prevFocused, email: false, }));
                    } else {
                        setError((prevState) => ({ ...prevState, email: false }));
                        setEmailErrorMessage('');
                        setFocused((prevFocused) => ({ ...prevFocused, email: true, }));
                    }
                }
            } else {
                // Handle the case where '@' is not present (optional)
                setError((prevState) => ({ ...prevState, email: false }));
                setFocused((prevFocused) => ({ ...prevFocused, email: false, }));
            }
        }

        if (fieldId === 'password') {
            setIsConfirmPasswordEnabled(false);
            setFocused((prevFocused) => ({ ...prevFocused, password: false }));
            if (value.length >= 8) {
                setIsConfirmPasswordEnabled(true);
                setFocused((prevFocused) => ({ ...prevFocused, password: true }));
                if (formValues.confirmPassword.length > 7) {
                    if (value !== formValues.confirmPassword) {
                        setError((prevState) => ({ ...prevState, confirmPassword: true }));
                        setConfirmPasswordErrorMessage('Passwords do not match');
                        setFocused((prevFocused) => ({ ...prevFocused, confirmPassword: false }));
                    } else {
                        setError((prevState) => ({ ...prevState, confirmPassword: false }));
                        setFocused((prevFocused) => ({ ...prevFocused, confirmPassword: true }));
                    }
                }
            }
            else if (value.length > 0 && value.length < 8) {
                setIsConfirmPasswordEnabled(false);
                setFocused((prevFocused) => ({ ...prevFocused, confirmPassword: false }));
                setError((prevState) => ({ ...prevState, confirmPassword: false }));
            }
            else {
                setFormValues((prevValues) => ({ ...prevValues, confirmPassword: '', }));
                setFocused((prevFocused) => ({ ...prevFocused, confirmPassword: false }));
                setError((prevState) => ({ ...prevState, confirmPassword: false }));
                setConfirmPasswordErrorMessage('');
                setShrinked((prevShrinked) => ({ ...prevShrinked, confirmPassword: false, }));
            }
        }

        if (fieldId === 'confirmPassword') {
            setFocused((prevFocused) => ({ ...prevFocused, confirmPassword: false }));
            if (value.length >= 8) {
                if (value !== formValues.password) {
                    setError((prevState) => ({ ...prevState, confirmPassword: true }));
                    setConfirmPasswordErrorMessage('Passwords do not match');
                }
                else {
                    setFocused((prevFocused) => ({ ...prevFocused, confirmPassword: true }));
                }
            }
        }
    };
    const [isTermsAccepted, setIsTermsAccepted] = useState(false);

    // Submit validation
    async function verifySignupExisting(event) {
        console.log(event)
        document.getElementById('loaderPage').style.display = 'flex';
        event.preventDefault();
        let isValid = true;

        // If all validations pass, proceed to signup verification to check email existence
        if (isValid) {
            setIsButtonDisabled(true);
            try {
                const { fullName, companyName, occupation, address, phoneNumber } = formValues;
                //console.log(fullName)
                const token = await AddTrialEmailAcc(email);
                setToken(token);
            } catch (error) {
                // Handle signup error
                console.error('Signup failed:', error);
                // Optionally, set error state or handle error UI
            }
            finally {
                document.getElementById('loaderPage').style.display = 'none';
                setIsButtonDisabled(false); // Re-enable the button after the process is complete
            }
        } else {
            document.getElementById('loaderPage').style.display = 'none';
        }
    };
    async function verifySignup(event) {
        console.log(event)
        document.getElementById('loaderPage').style.display = 'flex';
        event.preventDefault();
        let isValid = true;

        // If all validations pass, proceed to signup verification to check email existence
        if (isValid) {
            document.getElementById('loaderPage').style.display = 'none';
            setIsButtonDisabled(true);
            try {
                const { fullName, companyName, occupation, address, phoneNumber } = formValues;
                console.log(fullName)
                const token = await SignupTrial(email, fullName, companyName, occupation, address, phoneNumber);
                setToken(token);
            } catch (error) {
                // Handle signup error
                console.error('Signup failed:', error);
                // Optionally, set error state or handle error UI
            }
            finally {
                document.getElementById('loaderPage').style.display = 'none';
                setIsButtonDisabled(false); // Re-enable the button after the process is complete
            }
        } else {
            document.getElementById('loaderPage').style.display = 'none';
        }
    };

    return (<>

        {isVerify2 ?
            <div className="d-flex flex-column align-items-center justify-content-center vh-100 w-50 mx-auto text-center">
                {istrialmonth == true ? <>
                    <h5 style={{ color: '#727272', marginBottom: '10px' }}>Welcome to MIMS Drugs4dent.<br /><br /> 
Your 3-month FREE trial membership from Australian Dental Association has already been used. <br /> <br /> 
If you need assistance, please contact MIMS support at 1800 800 629 or support@mims.com.au </h5>
                    <br></br>
                    <Button
                        onClick={handleRedirect}
                        variant="contained"
                        color="primary"
                        sx={{
                            borderRadius: '32px',
                            padding: '16px 32px',
                            fontSize: '16px',
                            backgroundColor: '#0262AB',
                            '&:hover': { boxShadow: '0px 8px 24px 0px rgba(0, 153, 255, 0.15)' },
                        }}
                    >
                        Back to Login
                    </Button>
                </>
                    :
                    <>
                        {reason == 'backtologin' ?
                            <>
                                <h5 style={{ color: '#727272', marginBottom: '10px' }}>Welcome to MIMS Drugs4dent. Your Australian Dental Association (ADA) membership comes with a 3-month FREE trial of MIMS Drugs4dent. Please check your email for password </h5>
                                <Button
                                    onClick={handleRedirect}
                                    variant="contained"
                                    color="primary"
                                    sx={{
                                        borderRadius: '32px',
                                        padding: '16px 32px',
                                        fontSize: '16px',
                                        backgroundColor: '#0262AB',
                                        '&:hover': { boxShadow: '0px 8px 24px 0px rgba(0, 153, 255, 0.15)' },
                                    }}
                                >
                                    Back to login
                                </Button>
                            </>
                            :
                            <>
                                <h5 style={{ color: '#727272', marginBottom: '10px' }}>Welcome to MIMS Drugs4dent.<br /><br/>
 
Your Australian Dental Association membership gives you access to 3-months FREE Trial of MIMS Drugs4dent. Since you already have an account with MIMS Drugs4dent, we are pleased to add 3 FREE months to your existing license.<br /><br/>
 </h5>
                                <FormControlLabel control={<Checkbox checked={isTermsAccepted}
                                    onChange={(e) => setIsTermsAccepted(e.target.checked)} />} label={
                                        <span>I accept the{" "} <a href="https://www.mimsdrugs4dent.com/terms"
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            onClick={(e) => e.stopPropagation()}
                                            style={{
                                                color: "#0262AB",
                                                textDecoration: "underline",
                                                fontWeight: 500
                                            }}>Terms and Conditions</a></span>
                                    } />
                                <Button
                                    disabled={!isTermsAccepted}
                                    onClick={verifySignupExisting}
                                    variant="contained"
                                    color="primary"
                                    sx={{
                                        borderRadius: '32px',
                                        padding: '16px 32px',
                                        fontSize: '16px',
                                        backgroundColor: '#0262AB',
                                        '&:hover': { boxShadow: '0px 8px 24px 0px rgba(0, 153, 255, 0.15)' },
                                    }}
                                >
                                    Proceed
                                </Button>
                            </>
                        }
                    </>




                }

            </div>
            :
            <Container fluid id="signupPage">
                <Col lg={7} id="signupContainer" className="d-flex flex-column align-items-center justify-content-lg-start justify-content-md-between" >
                    <Box sx={{ width: '100%' }} id="signupForm">
                        <a href="/" className="d-lg-none d-md-flex align-self-center">
                            <img src="/Drugs4dent.svg" alt="Logo" id="signupLogo" className="align-self-start" />
                        </a>
                        <h1 style={{ marginBottom: '8px' }}>Sign Up</h1>
                        <p className="d-none d-lg-flex" style={{ marginBottom: '20px', color: '#727272' }}>
                            Welcome to MIMS Drugs4dent. Your Australian Dental Association (ADA) membership comes with a 3-month FREE trial of MIMS Drugs4dent.

                        </p>
                        <p>  Please enter your details below to proceed with the trial:</p>
                        <Box sx={{ mt: 0 }}>
                            <>
                                <form onSubmit={handleNext}>
                                    {formFields.slice(0, 5).map((field) => (
                                        <FormControl margin="normal" required fullWidth error={error[field.id]} key={field.id}>
                                            <TextField
                                                id={field.id}
                                                name={field.id}
                                                type={field.type}
                                                label={field.label}
                                                variant="outlined"
                                                value={formValues[field.id]}
                                                onChange={(e) => {
                                                    if (field.id === 'phoneNumber') {
                                                        const re = /^[0-9\b]+$/;
                                                        if (e.target.value === '' || re.test(e.target.value)) {
                                                            handleInputChange(field.id)(e);
                                                        }
                                                    } else {
                                                        handleInputChange(field.id)(e);
                                                    }
                                                }}
                                                fullWidth
                                                focused={focused[field.id]}
                                                error={error[field.id]}
                                                helperText={error[field.id] ? `${field.label} is required` : ''}
                                                InputProps={{
                                                    onAnimationStart: makeAnimationStartHandler(field.id),
                                                    startAdornment: <InputAdornment position="start">{field.icon}</InputAdornment>,
                                                    endAdornment: focused[field.id] ? (
                                                        <InputAdornment position="end">
                                                            <IconCheck className='validIcon' />
                                                        </InputAdornment>
                                                    ) : null,
                                                }}
                                                InputLabelProps={{
                                                    shrink: shrinked[field.id],
                                                    sx: { fontWeight: 'bold' },
                                                }}
                                            />
                                        </FormControl>
                                    ))}
                                    <FormControlLabel control={<Checkbox checked={isTermsAccepted}
                                        onChange={(e) => setIsTermsAccepted(e.target.checked)} />} label={
                                            <span>
                                                I accept the{" "}
                                                <a
                                                    href="https://www.mimsdrugs4dent.com/terms"
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    onClick={(e) => e.stopPropagation()}
                                                    style={{
                                                        color: "#0262AB",
                                                        textDecoration: "underline",
                                                        fontWeight: 500
                                                    }}
                                                >
                                                    Terms and Conditions
                                                </a>
                                            </span>
                                        } />
                                </form>
                            </>
                            <Button disabled={!isTermsAccepted} variant="contained" type="submit" className='proceedButton' onClick={verifySignup} fullWidth startIcon={<IconArrowForward />}>
                                Sign Up For a 3-Month Trial
                            </Button>
                        </Box>

                    </Box>

                </Col>
            </Container>


        }

    </>);
}

export default ActivateEmail;